import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo } from 'react';
import { useFilteredNotifications } from '../../store';
import timeGroupNotifications, { convertToTimeGroups } from '../../utils/time-group-notifications';
var useGroupedNotifications = function useGroupedNotifications(filters) {
  var _useFilteredNotificat = useFilteredNotifications(filters),
    _useFilteredNotificat2 = _slicedToArray(_useFilteredNotificat, 1),
    notifications = _useFilteredNotificat2[0];

  // state.notifications is already filtered from our custom selector
  // group notifications for consumption on the frontend
  return useMemo(function () {
    return timeGroupNotifications(notifications);
  }, [notifications]);
};
export default useGroupedNotifications;
export var useTimeGroupedNotificationGroups = function useTimeGroupedNotificationGroups(groups) {
  // TODO: Implement actual grouping by time
  return useMemo(function () {
    return convertToTimeGroups(groups);
  }, [groups]);
};